export const ORDER_PENDING = 'order_pending';
export const PRODUCT_NOT_IN_REGION = 'product_not_in_region';
export const MISSING_ZIP_CODE = 'missing_zip_code';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/cart-error-types.js